import { useMemo } from 'react';

import { useInboundReferralsActions } from 'stores/inboundReferralsStore';

import DateRangePicker, { DateRange } from './DateRangePicker';

// The History tab's Date Completed range (OLIO-3295), in the header slot the Create button holds
// on Active. `value` is the range in force (the page resolves the default). Unlike the Tasks
// range this one is never open-ended: the pickers cannot be cleared, so a blank field can never
// leave a stale range applied, and nothing later than today is offered.
export default function HistoryDateRange({ value }: { value: [Date, Date] }) {
  const { setDateRange } = useInboundReferralsActions();
  const maxDate = useMemo(() => new Date(), []);
  const range = useMemo<DateRange>(() => ({ start: value[0], end: value[1] }), [value]);

  // Only a real change reaches the store: a close that leaves the range where it was would
  // otherwise re-run the page's range effects (page reset) for nothing.
  const commit = ({ start, end }: DateRange) => {
    if (!start || !end) return;
    if (start.getTime() === value[0].getTime() && end.getTime() === value[1].getTime()) return;
    setDateRange([start, end]);
  };

  return (
    <DateRangePicker value={range} onChange={commit} testIdPrefix='history-date' clearable={false} maxDate={maxDate} />
  );
}
